import React, { useEffect, useState } from 'react';
import { usePopper } from 'react-popper';

import styles from './HelpBox.scss';

interface HelpBoxProps {
  parent: HTMLDivElement|HTMLButtonElement|null;
  children: React.ReactNode;
  dark?: boolean;
  popperStyles?: any;
}

const HelpBox:React.FC<HelpBoxProps> = ({ parent, children, dark = false }) => {
  const [tooltipRef, setTooltipRef] = useState<HTMLDivElement|null>(null);
  const [tooltipArrow, setTooltipArrow] = useState<HTMLDivElement|null>(null);

  const { styles: popperStyles, attributes, update } = usePopper(parent, tooltipRef, {
    placement: 'top',
    modifiers: [
      {
        name: 'arrow',
        options: {
          element: tooltipArrow,
        },
      },
    ],
  });

  useEffect(() => {
    if (update) {
      const interval = window.setInterval(() => update(), 1000);

      return () => window.clearInterval(interval);
    }
  }, [update, parent]);

  return (
    <div ref={setTooltipRef} style={popperStyles.popper} {...attributes.popper} className={`${styles.HelpBox} ${dark ? styles.HelpBox__Dark : ''}`}>
      { children }
      <div ref={setTooltipArrow} style={popperStyles.arrow} className={`${styles.HelpBox__Arrow} ${dark ? styles.HelpBox__Arrow__Dark : ''}`} />
    </div>
  );
};

export default HelpBox;
